export default "__VITE_ASSET__D1d2ti7M__"